import { render, staticRenderFns } from "./EditarItemCarteraAtencionV2.vue?vue&type=template&id=e6e3f290&scoped=true"
import script from "./EditarItemCarteraAtencionV2.vue?vue&type=script&lang=js"
export * from "./EditarItemCarteraAtencionV2.vue?vue&type=script&lang=js"
import style0 from "./EditarItemCarteraAtencionV2.vue?vue&type=style&index=0&id=e6e3f290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e3f290",
  null
  
)

export default component.exports